import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/faqs";

// FAQ section with collapsible items.
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-white py-16" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500">
            Quick answers about our service, warranty, and pricing.
          </p>
        </div>

        <div className="divide-y divide-gray-200 border-y border-gray-200">
          {FAQS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between py-5 text-left"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-gray-900 pr-6">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <p
                    className="text-gray-600 pb-5 pr-10 leading-relaxed"
                    data-testid={`faq-answer-${i}`}
                  >
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
